import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { AppProviders } from './app/providers';
import { initTelemetry } from './infrastructure/monitoring';
import './index.css';

// Initialize Enterprise Performance Monitoring & Crash Interception
initTelemetry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>,
);
